class QuickBuyProductForm extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.isPopupOpen = false
    this.productData = null
    this.productImages = []
    this.currentImageIndex = 0
    this.hoverDisabled = false
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.initialized) return

    this.productCard = this.closest('.product-card-wrapper') || this.closest('.card-wrapper')

    // Parse product images from JSON attribute
    this.parseProductImages()

    this.productHandle = this.getAttribute('data-product-handle')
    this.productId = this.getAttribute('data-product-id')

    // Popup behavior should work regardless of carousel mode.
    if (this.dataset.useCarousel !== 'false') {
      this.createNavigationHTML()
    }

    this.initialized = true
  }

  setupListeners () {
    super.setupListeners()

    this.handleTriggerClick = this.handleTriggerClick.bind(this)
    this.handleCloseClick = this.handleCloseClick.bind(this)
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    this.onPushCartBeforeAdd = this.onPushCartBeforeAdd.bind(this)
    this.handleVariantChange = this.handleVariantChange.bind(this)

    // Listeners for modal controls
    const trigger = this.querySelector('[data-quick-buy-trigger]')
    const closeBtn = this.querySelector('[data-quick-buy-close]')

    if (trigger) this.listeners.add(trigger, 'click', this.handleTriggerClick)
    if (closeBtn) this.listeners.add(closeBtn, 'click', this.handleCloseClick)

    // Listen for variant radio changes to update aria-checked
    const variantInputs = this.querySelectorAll('.qck-AddButton_VariantInput')
    variantInputs.forEach(input => {
      this.listeners.add(input, 'change', this.handleVariantChange)
    })

    // Close popup when cart add starts
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.BEFORE_ADD_FROM_FORM,
      this.onPushCartBeforeAdd,
    )
  }

  handleVariantChange (event) {
    // Update aria-checked on all labels
    const labels = this.querySelectorAll('.qck-AddButton_VariantOption')
    labels.forEach(label => {
      const input = label.querySelector('input[type="radio"]')
      label.setAttribute('aria-checked', input.checked ? 'true' : 'false')
    })
  }

  parseProductImages () {
    try {
      const productImagesAttr = this.getAttribute('data-product-images')
      if (productImagesAttr) {
        const imagesData = JSON.parse(productImagesAttr)

        this.productImages = imagesData
          .filter(media => media?.media_type === 'image')
          .slice(0, 3)
          .map(img => img.src || img)
      } else {
        this.productImages = []
      }
    } catch (error) {
      console.warn('Error parsing product images:', error)
      this.productImages = []
    }
  }

  handleTriggerClick (event) {
    event.preventDefault()
    event.stopPropagation()

    // Close other popups
    document.querySelectorAll('.qck-AddButton_Popup.popup-visible').forEach(popup => {
      if (popup !== this.popup) {
        popup.classList.remove('popup-visible')
      }
    })

    if (this.isPopupOpen) {
      this.closePopup()
    } else {
      this.openPopup()
    }
  }

  handleCloseClick (event) {
    event.preventDefault()
    event.stopPropagation()
    this.closePopup()
  }

  openPopup () {
    if (!this.popup) return

    this.popup.style.display = 'block'
    this.isPopupOpen = true

    if (!this.productCard) {
      this.productCard = this.closest('.product-card-wrapper') || this.closest('.card-wrapper')
    }

    if (this.productCard) {
      this.productCard.classList.add('quick-add-popup-open')
    }

    requestAnimationFrame(() => {
      this.popup.classList.add('popup-visible')
    })

    this.attachOutsideClickListener()
  }

  closePopup () {
    if (!this.popup) return

    this.popup.classList.remove('popup-visible')

    setTimeout(() => {
      this.popup.style.display = 'none'
      this.isPopupOpen = false

      if (this.productCard) {
        this.productCard.classList.remove('quick-add-popup-open')
      }

      this.removeOutsideClickListener()
    }, 200)
  }

  onPushCartBeforeAdd (event) {
    // Check if this form triggered the add
    const form = event.detail?.form
    if (form && this.contains(form)) {
      this.closePopup()
    }
  }

  attachOutsideClickListener () {
    document.addEventListener('click', this.handleOutsideClick)
  }

  removeOutsideClickListener () {
    document.removeEventListener('click', this.handleOutsideClick)
  }

  handleOutsideClick (event) {
    if (!this.contains(event.target)) {
      this.closePopup()
    }
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.removeOutsideClickListener()

    window.BAO.eventBus.removeEventListener(
      window.BAO.EVENTS.PUSH_CART.BEFORE_ADD_FROM_FORM,
      this.onPushCartBeforeAdd,
    )
  }

  createNavigationHTML () {
    if (!this.productCard) {
      return
    }

    if (this.productImages.length <= 1) {
      return
    }

    this.swiperContainer = this.productCard.querySelector('.card__inner')

    if (this.swiperContainer) {
      const progressContainer = document.createElement('div')
      progressContainer.className = 'product-nav-progress'
      progressContainer.innerHTML = `<div class="product-nav-progress-track"></div>`

      this.swiperContainer.appendChild(progressContainer)
      this.progressTrack = progressContainer.querySelector('.product-nav-progress-track')

      this.updateProgressBar()

      this.handlePointerDown = this.handlePointerDown.bind(this)
      this.handlePointerMove = this.handlePointerMove.bind(this)
      this.handlePointerUp = this.handlePointerUp.bind(this)

      this.swiperContainer.style.touchAction = 'pan-y'
      this.swiperContainer.style.cursor = 'grab'

      this.swiperContainer.addEventListener('pointerdown', this.handlePointerDown)
    }
  }

  handlePointerDown (e) {
    if (e.target.closest('.qck-AddButton, wishlist-button, .card__wishlist-add, [data-quick-buy-trigger]')) {
      return
    }

    if (e.pointerType === 'mouse') {
      e.preventDefault()
    }

    e.currentTarget.setPointerCapture(e.pointerId)

    this.isDragging = true
    this.hasDragged = false
    this.pointerStartX = e.clientX
    this.pointerStartY = e.clientY
    this.pointerStartTime = Date.now()

    this.swiperContainer.style.cursor = 'grabbing'

    this.swiperContainer.addEventListener('pointermove', this.handlePointerMove)
    this.swiperContainer.addEventListener('pointerup', this.handlePointerUp)
  }

  handlePointerMove (e) {
    if (!this.isDragging) return

    const deltaX = e.clientX - this.pointerStartX
    const deltaY = e.clientY - this.pointerStartY

    if (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5) {
      this.hasDragged = true
    }
  }

  handlePointerUp (e) {
    if (!this.isDragging) return

    this.isDragging = false
    this.swiperContainer.style.cursor = 'grab'

    e.currentTarget.releasePointerCapture(e.pointerId)
    this.swiperContainer.removeEventListener('pointermove', this.handlePointerMove)
    this.swiperContainer.removeEventListener('pointerup', this.handlePointerUp)

    const deltaX = e.clientX - this.pointerStartX
    const deltaY = e.clientY - this.pointerStartY
    const dragDuration = Date.now() - this.pointerStartTime

    const minSwipeDistance = 50
    const maxSwipeTime = 1000

    if (this.hasDragged) {
      const stopClick = (clickEvent) => {
        clickEvent.preventDefault()
        clickEvent.stopPropagation()
      }

      this.swiperContainer.addEventListener('click', stopClick, { capture: true, once: true })
    }

    if (Math.abs(deltaX) > Math.abs(deltaY) &&
      Math.abs(deltaX) > minSwipeDistance &&
      dragDuration < maxSwipeTime) {
      const direction = deltaX > 0 ? 'prev' : 'next'

      this.navigateImage(direction)
    }
  }

  navigateImage (direction) {
    // Calculate new index with circular navigation
    if (direction === 'prev') {
      this.currentImageIndex = this.currentImageIndex > 0
        ? this.currentImageIndex - 1
        : this.productImages.length - 1
    } else {
      this.currentImageIndex = this.currentImageIndex < this.productImages.length - 1
        ? this.currentImageIndex + 1
        : 0
    }

    // Update the product image
    this.updateProductImage()

    this.updateProgressBar()
  }

  updateProgressBar () {
    if (!this.progressTrack) return

    if (this.productImages.length <= 1) {
      this.progressTrack.style.display = 'none'
      return
    }

    this.progressTrack.style.display = 'block'

    const step = 100 / this.productImages.length

    this.progressTrack.style.width = `${step}%`

    const offset = this.currentImageIndex * 100

    this.progressTrack.style.transform = `translateX(${offset}%)`
  }

  updateProductImage () {
    if (!this.productImages || this.productImages.length === 0) {
      return
    }

    const currentImageUrl = this.productImages[this.currentImageIndex]

    // Target the specific card media structure
    const cardMedia = this.productCard.querySelector('.card__media')
    const mediaContainer = cardMedia?.querySelector('.media')
    const mainImage = mediaContainer?.querySelector('img:first-child')

    if (mainImage && currentImageUrl) {
      // Generate the main image source with proper Shopify sizing
      const newSrc = currentImageUrl

      if (!currentImageUrl) return

      const newSrcset = this.generateShopifySrcset(currentImageUrl)

      // Update the image attributes
      mainImage.src = newSrc
      mainImage.srcset = newSrcset
      mainImage.alt = `Product image ${this.currentImageIndex + 1}`

      // Keep the existing sizes attribute for responsive behavior
      if (!mainImage.getAttribute('sizes')) {
        mainImage.setAttribute('sizes',
          '(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)',
        )
      }
    }
  }

  generateShopifySrcset (imageUrl) {
    const widths = [165, 360, 533, 720, 940, 1066]
    const srcsetParts = []

    // Get the base URL without size parameters
    const baseUrl = imageUrl.split('?')[0]
    const extension = baseUrl.split('.').pop()
    const urlWithoutExtension = baseUrl.replace(`.${extension}`, '')

    // Generate srcset for each width
    widths.forEach(width => {
      srcsetParts.push(`${urlWithoutExtension}_${width}x.${extension} ${width}w`)
    })

    // Add the original image as the largest size
    srcsetParts.push(`${baseUrl} 1200w`)

    return srcsetParts.join(', ')
  }

  get popup () {
    return this.querySelector('[data-quick-buy-popup]')
  }
}

// Define the custom element
customElements.define('quick-buy-product-form', QuickBuyProductForm)
